import { Button, Typography } from '@mui/material';
import React from 'react';

const FilledBtn = ({ btnText, btnIcon, bgColor, fontSize, onClick, disabled = false, px }) => {
  return (
    <div>
      <Button
        onClick={onClick}
        variant="contained"
        sx={{
          padding: btnIcon ? '10px 0px 3px 0px' : '10px 18px',
          paddingX: px && px,
          borderRadius: '12px',
          backgroundColor: btnIcon ? '#fff' : bgColor,
          border: btnIcon ? '1px solid white' : `1px solid ${bgColor}`,
          '&:hover': { backgroundColor: '#fff', color: bgColor, border: `1px solid ${bgColor}` },
          '&:disabled': { border: 'none', backgroundColor: `${bgColor}80`, color: '#fff' }
        }}
        disabled={disabled}
      >
        <Typography sx={{ fontSize: fontSize, fontFamily: 'Poppins', lineHeight: '20px', whiteSpace: 'nowrap', fontWeight: 600 }}>
          {btnText ? btnText : btnIcon ? btnIcon : ''}
        </Typography>
      </Button>
    </div>
  );
};

export default FilledBtn;
